import { Confirmation } from '@collector/sportsapi-client-legacy'

import { NavigationButton, PopupContext } from '../types'
import { PopupButtonProps } from './PopupButton/PopupButton'
import PopupButton from './PopupButton/PopupButton.vue'

export function useConfirmationButton(
  options?: Partial<PopupButtonProps>,
): NavigationButton {
  return {
    component: PopupButton,
    props: {
      text: options?.text ?? 'Confirmed',
      color: 'green',
      attributes: options?.attributes ?? {},
      onClick: (context: PopupContext | null) => {
        context?.incidentActionComposable?.updateIncident({
          confirmation: Confirmation.Confirmed,
        })
        if (options?.onClick) options.onClick(context)
        else context?.closePopup()
      },
    },
  }
}
